<div class="feed-form">
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="save()">
    <p class="hint">
      Each criterion is a percentage of the feed's total ranking influence.
      All percentages must sum to <strong>100%</strong>. The direction
      (boost vs. push-down for diversity) is fixed; you control the strength.
    </p>

    <table class="algo-table">
      <thead>
        <tr>
          <th class="col-criteria">Criteria</th>
          <th class="col-type">Type</th>
          <th class="col-pct">Percentage</th>
          <th class="col-default">Default</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of parameters">
          <td class="col-criteria">{{ p.label }}</td>
          <td class="col-type">
            <span class="badge" [class.boost]="p.direction === 'boost'" [class.penalty]="p.direction === 'penalty'">
              {{ p.direction === 'boost' ? 'Boost' : 'Diversity' }}
            </span>
          </td>
          <td class="col-pct">
            <mat-form-field appearance="outline" class="param-input" subscriptSizing="dynamic">
              <input matInput type="number" min="0" max="100" step="0.5" [formControlName]="p.key" />
              <span matTextSuffix>%</span>
            </mat-form-field>
          </td>
          <td class="col-default">{{ p.defaultPercent | number: '1.0-2' }}%</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row" [class.ok]="isBalanced" [class.bad]="!isBalanced">
          <td colspan="2"><strong>Total</strong></td>
          <td class="col-pct">
            <strong>{{ totalRounded }}%</strong>
            <span *ngIf="isBalanced" class="good" title="balanced">&#10003;</span>
            <span *ngIf="!isBalanced" class="warn" title="must equal 100%">&#9888;</span>
          </td>
          <td class="col-default">100%</td>
        </tr>
      </tfoot>
    </table>

    <div *ngIf="!isBalanced" class="balance-warning">
      Percentages currently total <strong>{{ totalRounded }}%</strong> — they must equal 100%
      before saving. Use <em>Normalize to 100%</em> to rescale automatically.
    </div>

    <div class="actions">
      <button mat-stroked-button type="button" (click)="normalize()">Normalize to 100%</button>
      <button mat-stroked-button type="button" (click)="fillDefaults()">Preview defaults</button>
      <button mat-stroked-button color="warn" type="button" (click)="resetToDefaults()" [disabled]="resetting">
        <mat-spinner *ngIf="resetting" diameter="18"></mat-spinner>
        <span *ngIf="!resetting">Reset to defaults</span>
      </button>
      <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || saving">
        <mat-spinner *ngIf="saving" diameter="18"></mat-spinner>
        <span *ngIf="!saving">Save</span>
      </button>
    </div>
    <p class="hint reset-hint">
      <strong>Reset to defaults</strong> clears the saved override and reverts this
      feed to the built-in weights immediately. <strong>Preview defaults</strong> only
      fills the form (not saved until you press Save).
    </p>
  </form>
</div>
